import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Loader from './components/Loader/Loader';
import Login from './components/Login/Login';

import Header from './components/Header/Header';
import Sidebar from './components/Sidebar/Sidebar';
import Main from './components/Main/Init'
import Footer from './components/Footer/Footer';

import Structure from './components/WEBContent/Structure/Init'

import Formador from './components/Entities/Formador/Init'
import Formando from './components/Entities/Formando/Init'
import Note from './components/Notes/Init'
import Message from './components/Messages/Init'

import Utilizador from './components/Entities/Utilizador/Init'

//import Corporate from './components/Corporate/Corporate'
import TermosCondicoes from './components/Termos/TermosCondicoes'
import PoliticaPrivacidade from './components/Termos/PoliticaPrivacidade'

import Calendar_Event from './components/Calendar/Event/Init'
import Calendar_Category from './components/Calendar/Category/Init'
import Courses from './components/Courses/Init'

import Content from './components/WEBContent/Content/Init'
import Content_News from './components/WEBContent/News/Init'
import Content_Banner from './components/WEBContent/Banner/Init'
import Content_Gallery from './components/WEBContent/Gallery/Init'
import Content_Testemony from './components/WEBContent/Testemony/Init'
import Content_Category from './components/WEBContent/Category/Init'

import Content_Contest from './components/WEBContent/Contest/Init'

import Formation_Courses from './components/Formation/Courses/Init'
import Formation_Category from './components/Formation/Category/Init'
import Formation_Module from './components/Formation/Module/Init'



import MonitoringEntity from './components/Entities/Entidade/Init'
import MonitoringOperation from './components/Energy/Operation/Init'
import MonitoringConsumos from './components/Energy/Consumos/Init'
import MonitoringAutoConsumo from './components/Energy/Autoconsumo/Init'
import MonitoringPlanoAccao from './components/Energy/PlanoAccao/Init'
import MonitoringResultados from './components/Energy/Resultados/Init'



import Perfil from './components/WEBContent/PerfisMenus/Init'

import useToken from './UseToken';

import {
  repo_favicon_link,
} from './Utils';

document.title = `${document.title}`

//if (process.env.REACT_APP_MODE === 'production') console.log = function () { };

function App() {

  const { token, setToken } = useToken();

  const [isloading, setLoading] = useState(true);

  const handleFavIcon = () => {
    function getFaviconEl() {
      return document.getElementById("favicon");
    }

    const favicon = getFaviconEl(); // Accessing favicon element

    favicon.href = repo_favicon_link("favicon.ico");
  };

  handleFavIcon()

  useEffect(() => {

    if (token) {
      setLoading(false)
    }

    return () => { };

  }, [token])

  if (!token) {
    //console.log('---> APP.JS: ANTES DO TOKEN')
    return <Login setToken={setToken} />
  }

  let checkAuthorization = (path, component) => {
    return component
  }

  return isloading ?
    <Loader />
    :
    <>
      <Header />
      <Sidebar
      /*
      sidebar_info = {
        sideBarData
      }
      */
      />
      <div className="main-content">

        <Switch>

          <Route path={Main.view.endpoint} exact
            component={checkAuthorization(Main.view, Main.view.component)}
          />

          <Route path={Structure.regist.endpoint} exact
            component={checkAuthorization(Structure.regist.endpoint, Structure.regist.component)}
          />

          <Route path={Structure.list.endpoint} exact
            component={checkAuthorization(Structure.list.endpoint, Structure.list.component)}
          />

          <Route path={Structure.view.endpoint} exact
            component={checkAuthorization(Structure.view.endpoint, Structure.view.component)}
          />

          <Route path={Formador.regist.endpoint} exact
            component={checkAuthorization(Formador.regist.endpoint, Formador.regist.component)}
          />

          <Route path={Formador.list.endpoint} exact
            component={checkAuthorization(Formador.list.endpoint, Formador.list.component)}
          />

          <Route path={Formador.view.endpoint} exact
            component={checkAuthorization(Formador.view.endpoint, Formador.view.component)}
          />

          <Route path={Formando.regist.endpoint} exact
            component={checkAuthorization(Formando.regist.endpoint, Formando.regist.component)}
          />

          <Route path={Formando.list.endpoint} exact
            component={checkAuthorization(Formando.list.endpoint, Formando.list.component)}
          />

          <Route path={Formando.view.endpoint} exact
            component={checkAuthorization(Formando.view.endpoint, Formando.view.component)}
          />

          <Route path={Note.list.endpoint} exact
            component={checkAuthorization(Note.list, Note.list.component)}
          />

          <Route path={Note.view.endpoint} exact
            component={checkAuthorization(Note.view, Note.view.component)}
          />

          <Route path={Note.regist.endpoint} exact
            component={checkAuthorization(Note.regist, Note.regist.component)}
          />

          <Route path={Message.list.endpoint} exact
            component={checkAuthorization(Message.list, Message.list.component)}
          />

          <Route path={Message.view.endpoint} exact
            component={checkAuthorization(Message.view, Message.view.component)}
          />

          <Route path={Message.regist.endpoint} exact
            component={checkAuthorization(Message.regist, Message.regist.component)}
          />

          <Route path={Utilizador.regist.endpoint} exact
            component={checkAuthorization(Utilizador.regist.endpoint, Utilizador.regist.component)}
          />

          <Route path={Utilizador.list.endpoint} exact
            component={checkAuthorization(Utilizador.list.endpoint, Utilizador.list.component)}
          />

          <Route path={Utilizador.view.endpoint} exact
            component={checkAuthorization(Utilizador.view.endpoint, Utilizador.view.component)}
          />

          <Route path={Calendar_Event.view.endpoint} exact
            component={checkAuthorization(Calendar_Event.view, Calendar_Event.view.component)}
          />

          <Route path={Calendar_Category.list.endpoint} exact
            component={checkAuthorization(Calendar_Category.list, Calendar_Category.list.component)}
          />

          <Route path={Calendar_Category.view.endpoint} exact
            component={checkAuthorization(Calendar_Category.view, Calendar_Category.view.component)}
          />

          <Route path={Calendar_Category.regist.endpoint} exact
            component={checkAuthorization(Calendar_Category.regist, Calendar_Category.regist.component)}
          />

          <Route path={Courses.list.endpoint} exact
            component={checkAuthorization(Courses.list, Courses.list.component)}
          />

          <Route path={Courses.view.endpoint} exact
            component={checkAuthorization(Courses.view, Courses.view.component)}
          />

          <Route path={Courses.regist.endpoint} exact
            component={checkAuthorization(Courses.regist, Courses.regist.component)}
          />

          <Route path={Content.list.endpoint} exact
            component={checkAuthorization(Content.list, Content.list.component)}
          />

          <Route path={Content.view.endpoint} exact
            component={checkAuthorization(Content.view, Content.view.component)}
          />

          <Route path={Content.regist.endpoint} exact
            component={checkAuthorization(Content.regist, Content.regist.component)}
          />

          <Route path={Content_Category.list.endpoint} exact
            component={checkAuthorization(Content_Category.list, Content_Category.list.component)}
          />

          <Route path={Content_Category.view.endpoint} exact
            component={checkAuthorization(Content_Category.view, Content_Category.view.component)}
          />

          <Route path={Content_Category.regist.endpoint} exact
            component={checkAuthorization(Content_Category.regist, Content_Category.regist.component)}
          />

          <Route path={Content_News.list.endpoint} exact
            component={checkAuthorization(Content_News.list, Content_News.list.component)}
          />

          <Route path={Content_News.view.endpoint} exact
            component={checkAuthorization(Content_News.view, Content_News.view.component)}
          />

          <Route path={Content_News.regist.endpoint} exact
            component={checkAuthorization(Content_News.regist, Content_News.regist.component)}
          />

          <Route path={Content_Banner.list.endpoint} exact
            component={checkAuthorization(Content_Banner.list, Content_Banner.list.component)}
          />

          <Route path={Content_Banner.view.endpoint} exact
            component={checkAuthorization(Content_Banner.view, Content_Banner.view.component)}
          />

          <Route path={Content_Banner.regist.endpoint} exact
            component={checkAuthorization(Content_Banner.regist, Content_Banner.regist.component)}
          />

          <Route path={Content_Gallery.list.endpoint} exact
            component={checkAuthorization(Content_Gallery.list, Content_Gallery.list.component)}
          />

          <Route path={Content_Gallery.view.endpoint} exact
            component={checkAuthorization(Content_Gallery.view, Content_Gallery.view.component)}
          />

          <Route path={Content_Gallery.regist.endpoint} exact
            component={checkAuthorization(Content_Gallery.regist, Content_Gallery.regist.component)}
          />

          <Route path={Content_Testemony.list.endpoint} exact
            component={checkAuthorization(Content_Testemony.list, Content_Testemony.list.component)}
          />

          <Route path={Content_Testemony.view.endpoint} exact
            component={checkAuthorization(Content_Testemony.view, Content_Testemony.view.component)}
          />

          <Route path={Content_Testemony.regist.endpoint} exact
            component={checkAuthorization(Content_Testemony.regist, Content_Testemony.regist.component)}
          />

          <Route path={Content_Contest.list.endpoint} exact
            component={checkAuthorization(Content_Contest.list, Content_Contest.list.component)}
          />

          <Route path={Content_Contest.view.endpoint} exact
            component={checkAuthorization(Content_Contest.view, Content_Contest.view.component)}
          />

          <Route path={Content_Contest.regist.endpoint} exact
            component={checkAuthorization(Content_Contest.regist, Content_Contest.regist.component)}
          />

          <Route path={Formation_Courses.list.endpoint} exact
            component={checkAuthorization(Formation_Courses.list, Formation_Courses.list.component)}
          />

          <Route path={Formation_Courses.list2.endpoint} exact
            component={checkAuthorization(Formation_Courses.list2, Formation_Courses.list2.component)}
          />

          <Route path={Formation_Courses.view.endpoint} exact
            component={checkAuthorization(Formation_Courses.view, Formation_Courses.view.component)}
          />

          <Route path={Formation_Courses.regist.endpoint} exact
            component={checkAuthorization(Formation_Courses.regist, Formation_Courses.regist.component)}
          />

          <Route path={Formation_Courses.gest.endpoint} exact
            component={checkAuthorization(Formation_Courses.gest, Formation_Courses.gest.component)}
          />

          <Route path={Formation_Category.list.endpoint} exact
            component={checkAuthorization(Formation_Category.list, Formation_Category.list.component)}
          />

          <Route path={Formation_Category.view.endpoint} exact
            component={checkAuthorization(Formation_Category.view, Formation_Category.view.component)}
          />

          <Route path={Formation_Category.regist.endpoint} exact
            component={checkAuthorization(Formation_Category.regist, Formation_Category.regist.component)}
          />

          <Route path={Formation_Module.list.endpoint} exact
            component={checkAuthorization(Formation_Module.list, Formation_Module.list.component)}
          />

          <Route path={Formation_Module.view.endpoint} exact
            component={checkAuthorization(Formation_Module.view, Formation_Module.view.component)}
          />

          <Route path={Formation_Module.regist.endpoint} exact
            component={checkAuthorization(Formation_Module.regist, Formation_Module.regist.component)}
          />

          <Route path={Formation_Module.gest.endpoint} exact
            component={checkAuthorization(Formation_Module.gest, Formation_Module.gest.component)}
          />

          <Route path={Formation_Module.evaluation.endpoint} exact
            component={checkAuthorization(Formation_Module.evaluation, Formation_Module.evaluation.component)}
          />









          <Route path={MonitoringEntity.list.endpoint} exact
            component={checkAuthorization(MonitoringEntity.list, MonitoringEntity.list.component)}
          />

          <Route path={MonitoringEntity.view.endpoint} exact
            component={checkAuthorization(MonitoringEntity.view, MonitoringEntity.view.component)}
          />

          <Route path={MonitoringEntity.regist.endpoint} exact
            component={checkAuthorization(MonitoringEntity.regist, MonitoringEntity.regist.component)}
          />

          <Route path={MonitoringOperation.list.endpoint} exact
            component={checkAuthorization(MonitoringOperation.list, MonitoringOperation.list.component)}
          />

          <Route path={MonitoringOperation.view.endpoint} exact
            component={checkAuthorization(MonitoringOperation.view, MonitoringOperation.view.component)}
          />

          <Route path={MonitoringOperation.regist.endpoint} exact
            component={checkAuthorization(MonitoringOperation.regist, MonitoringOperation.regist.component)}
          />

          <Route path={MonitoringConsumos.list.endpoint} exact
            component={checkAuthorization(MonitoringConsumos.list, MonitoringConsumos.list.component)}
          />

          <Route path={MonitoringConsumos.view.endpoint} exact
            component={checkAuthorization(MonitoringConsumos.view, MonitoringConsumos.view.component)}
          />

          <Route path={MonitoringConsumos.regist.endpoint} exact
            component={checkAuthorization(MonitoringConsumos.regist, MonitoringConsumos.regist.component)}
          />

          <Route path={MonitoringAutoConsumo.list.endpoint} exact
            component={checkAuthorization(MonitoringAutoConsumo.list, MonitoringAutoConsumo.list.component)}
          />

          <Route path={MonitoringAutoConsumo.view.endpoint} exact
            component={checkAuthorization(MonitoringAutoConsumo.view, MonitoringAutoConsumo.view.component)}
          />

          <Route path={MonitoringAutoConsumo.regist.endpoint} exact
            component={checkAuthorization(MonitoringAutoConsumo.regist, MonitoringAutoConsumo.regist.component)}
          />

          <Route path={MonitoringPlanoAccao.list.endpoint} exact
            component={checkAuthorization(MonitoringPlanoAccao.list, MonitoringPlanoAccao.list.component)}
          />

          <Route path={MonitoringPlanoAccao.view.endpoint} exact
            component={checkAuthorization(MonitoringPlanoAccao.view, MonitoringPlanoAccao.view.component)}
          />

          <Route path={MonitoringPlanoAccao.regist.endpoint} exact
            component={checkAuthorization(MonitoringPlanoAccao.regist, MonitoringPlanoAccao.regist.component)}
          />

          <Route path={MonitoringResultados.list.endpoint} exact
            component={checkAuthorization(MonitoringResultados.list, MonitoringResultados.list.component)}
          />

          <Route path={MonitoringResultados.view.endpoint} exact
            component={checkAuthorization(MonitoringResultados.view, MonitoringResultados.view.component)}
          />

          <Route path={MonitoringResultados.regist.endpoint} exact
            component={checkAuthorization(MonitoringResultados.regist, MonitoringResultados.regist.component)}
          />










          {/*   <Route path="/" exact component={Main} />Main */}

          <Route path={Main.view.endpoint} exact component={Main.view.component} />

          {/* <Route path="/corporate" exact component={
            checkAuthorization("/corporate", Corporate)
          } /> */}

          <Route path="/terms_conditions" exact component={
            checkAuthorization("/terms_conditions", TermosCondicoes)
          } />

          <Route path="/privacy_policy" exact component={
            checkAuthorization("/privacy_policy", PoliticaPrivacidade)
          } />



          <Route path={Perfil.regist.endpoint} exact
            component={checkAuthorization(Perfil.regist.endpoint, Perfil.regist.component)} />

          <Route path={Perfil.list.endpoint} exact
            component={checkAuthorization(Perfil.list.endpoint, Perfil.list.component)} />

          <Route path={Perfil.view.endpoint} exact
            component={checkAuthorization(Perfil.view.endpoint, Perfil.view.component)} />




          {/* QUANDO O ENDEREÇO NÃO É VÁLIDO */}
          {/* <Route path='*' component={() => <Redirect to="/" />} /> */}
          <Route path='*' component={() => <Redirect to="/" />} />

        </Switch >
      </div >
      <Footer />

    </>

}

export default App;


/*

    <Route path="/corporate" exact={true} component={Corporate} />
             <Corporate inputsContent={CorporateContent} onSubmit={() => //console.log('oiiiiiiiiiiiii')} />    </Route>


        <Route path="/user" exact>
          <User inputsContent={UserContent} onSubmit={() => //console.log('oiiiiiiiiiiiii')} />
        </Route>

        <Route path="/preferences" >
          <Preferences />
        </Route>

        <Route path="/datatable">
          <DataTable
                                    noDataComponent='Sem Registos'Example />
        </Route>

        <Route path="/datatable2">
          <DataTable
                                    noDataComponent='Sem Registos'Example2 />
        </Route>

        <Route path="/form">
          <FormTemplate inputsContent={FormContent} onSubmit={() => //console.log('oiiiiiiiiiiiii')} />
        </Route>
        */


/*

import ColaboradorLista from './components/Colaborador/ColaboradorLista';
import Colaborador from './components/Colaborador/Colaborador';
import ColaboradorView from './components/Colaborador/ColaboradorView';

import PromotorLista from './components/Promotor/PromotorLista';
import Promotor from './components/Promotor/Promotor';
import PromotorView from './components/Promotor/PromotorView';

import EscritorioLista from './components/Escritorio/EscritorioLista';
import Escritorio from './components/Escritorio/Escritorio';
import EscritorioView from './components/Escritorio/EscritorioView';

import MasterBlank from './components/Master/MasterBlank';
import MasterLista from './components/Master/MasterLista';
import Master from './components/Master/Master';

*/